export default __webpack_public_path__ + "images/CP.6c7394d.png";